import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateFilter from './date';
import moment from 'moment';

class BoxDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      selectedDateFrom: null,
      text: ''
    };
  }

  componentWillMount() {
    let restFrom = moment(this.props.dateFrom).utc() + this.props.difFrom;
    let restTo = moment(this.props.dateTo).utc() + this.props.difTo;
    this.setState({
      selectedDateFrom: moment(restFrom).format('DD-MM-YYYY'),
      selectedDateTo: moment(restTo).format('DD-MM-YYYY'),
      text: `${moment(restFrom).format('MM/DD')} - ${moment(restTo).format('MM/DD')}`
    });
  }

  handleHide = event => {
    if (event.target.id == 'input-date') {
      this.setState({
        active: this.state.active ? false : true
      });
    }
  };

  handleMonth = event => {
    const startOfMonth = moment()
      .startOf('month')
      .format('DD-MM-YYYY');
    const endOfMonth = moment()
      .endOf('month')
      .format('DD-MM-YYYY');

    this.setState({
      selectedDateFrom: startOfMonth,
      selectedDateTo: endOfMonth,
      text: 'Este mes',
      active: false
    });
  };

  handleWeek = event => {
    const startOfMonth = moment()
      .startOf('week')
      .format('DD-MM-YYYY');
    const endOfMonth = moment()
      .endOf('week')
      .format('DD-MM-YYYY');

    this.setState({
      selectedDateFrom: startOfMonth,
      selectedDateTo: endOfMonth,
      text: 'Esta semana',
      active: false
    });
  };

  handleLastMonth = event => {
    const startOfMonth = moment()
      .subtract(3, 'months')
      .format('DD-MM-YYYY');
    const endOfMonth = moment().format('DD-MM-YYYY');

    this.setState({
      selectedDateFrom: startOfMonth,
      selectedDateTo: endOfMonth,
      text: 'Último 3 meses',
      active: false
    });
  };

  handleYear = event => {
    const startOfMonth = moment()
      .startOf('year')
      .format('DD-MM-YYYY');
    const endOfMonth = moment()
      .endOf('year')
      .format('DD-MM-YYYY');

    this.setState({
      selectedDateFrom: startOfMonth,
      selectedDateTo: endOfMonth,
      text: 'Este año',
      active: false
    });
  };

  handleAllTime = event => {
    const startOfMonth = null;
    const endOfMonth = null;

    this.setState({
      selectedDateFrom: startOfMonth,
      selectedDateTo: endOfMonth,
      text: 'Todo el tiempo',
      active: false
    });
  };

  handleCustom = obj => {
    const start = document.getElementById('date-start');
    const end = document.getElementById('date-end');

    if (obj.id == 'date-start') {
      this.setState({
        selectedDateFrom: moment(obj.date).format('DD-MM-YYYY'),
        selectedDateTo: moment(end.value, 'DD-MM-YYYY').format('DD-MM-YYYY'),
        text: `${moment(obj.date).format('MM/DD')} - ${moment(end.value, 'DD-MM-YYYY').format(
          'MM/DD'
        )}`
      });
    } else {
      this.setState({
        selectedDateFrom: moment(start.value, 'DD-MM-YYYY').format('DD-MM-YYYY'),
        selectedDateTo: moment(obj.date).format('DD-MM-YYYY'),
        text: `${moment(start.value, 'DD-MM-YYYY').format('MM/DD')} - ${moment(obj.date).format(
          'MM/DD'
        )}`
      });
    }
  };

  render() {
    return (
      <div>
        <ul className="buttom_menu_date" onClick={this.handleHide}>
          <li
            id="input-date"
            data-from={this.state.selectedDateFrom}
            data-to={this.state.selectedDateTo}
          >
            {this.state.text}
            <ul className={this.state.active ? 'active' : ''}>
              <li onClick={this.handleMonth}>
                <a>Este mes</a>
              </li>
              <li onClick={this.handleWeek}>
                <a>Esta semana</a>
              </li>
              <li onClick={this.handleLastMonth}>
                <a>Último 3 meses</a>
              </li>
              <li onClick={this.handleYear}>
                <a>Este año</a>
              </li>
              <li onClick={this.handleAllTime}>
                <a>Todo el tiempo</a>
              </li>
              <li>
                <a>Customizar</a>
              </li>
              <li>
                <a className="flex">
                  <div className="padding-right">
                    <label className="special">Desde</label>
                    <DateFilter
                      date={1532985125137}
                      dif={-1209600000}
                      id="date-start"
                      handleSubmit={this.props.handleSubmit}
                      handleCustom={this.handleCustom}
                    />
                  </div>
                  <div className="padding-left">
                    <label className="special">Hasta</label>
                    <DateFilter
                      date={1532985125137}
                      dif={-1209600000}
                      id="date-end"
                      handleSubmit={this.props.handleSubmit}
                      handleCustom={this.handleCustom}
                    />
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    );
  }
}

export default BoxDate;



// WEBPACK FOOTER //
// ./source/client/components/common/date/index.jsx